import { render, staticRenderFns } from "./surgeryReport.vue?vue&type=template&id=7fb988d8"
import script from "./surgeryReport.vue?vue&type=script&lang=js"
export * from "./surgeryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports